<div class="global-search">
    <button class="search-button" (click)="openModal()" [disabled]="isLoading" type="button" aria-label="Toggle Search">
        <span class="cvoc-icon"></span>
        <span class="arrow-down-icon" [class.rotate]="isRotated"></span>
    </button>    <div class="selected-text" *ngIf="showSelected && !isLoading">
        {{ selectedData ? selectedData.primaryText : 'COMMON.GLOBAL_SEARCH.ALL_ACCOUNTS' | translate }}
        <div class="sub-text" *ngIf="shouldShowSearchCounts">
            <span *ngIf="shouldShowAccountCount">{{ searchCounts?.corporateAccountCount }} {{'COMMON.GLOBAL_SEARCH.ACCOUNTS' | translate}} |
            </span>
            <span *ngIf="shouldShowSiteCount">{{ searchCounts?.siteCount }} {{'COMMON.GLOBAL_SEARCH.SITES' | translate}}</span>
        </div>
        <div class="sub-text" *ngIf="selectedData?.secondaryText">
            <span [innerHTML]="selectedData?.secondaryText"></span>
        </div>
    </div>
</div>